import { FLOW_COLOR } from 'constants/App';

export default {
  palette: {
    background: {
      default: '#FFF',
    },
    primary: {
      main: FLOW_COLOR,
      contrastText: '#FFF',
    },
    secondary: {
      main: 'rgba(12, 179, 228)',
      contrastText: '#FFF',
    },
    error: {
      main: 'rgba(188, 56, 56, 1)',
    },
    text: {
      primary: '#262626',
      secondary: 'rgba(61, 61, 61, 0.85)', // OP grey = #616161
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          color: '#262626',
          fontFamily: 'Roboto',
          letterSpacing: -0.5,
        },
        '.loginCardTitle': {
          color: FLOW_COLOR,
          fontSize: 20,
          fontWeight: 500,
        },
        '.app-content-wrapper': {
          /* backgroundColor: '#f8f9fa;', */
        },
        '.title': {
          color: FLOW_COLOR,
          fontSize: 28,
          fontWeight: 500,
        },
        '.logoSubtitle': {
          color: FLOW_COLOR,
          fontSize: 10,
          fontWeight: 600,
          marginBottom: 0,
        },
        header: {
          background: '#FFF',
          borderBottom: '1px solid rgba(0, 0, 0, .05)',
        },
        footer: {
          background: '#FFF',
          marginTop: '25px',
          borderTop: '1px solid rgba(0, 0, 0, .05)',
          fontSize: '11px',
          lineHeight: '17px',
          color: '#636c72',
        },
      },
    },
    MuiTab: {
      root: {
        backgroundColor: FLOW_COLOR,
        '&:hover': {
          opacity: 0.9,
        },
      },
      textColorInherit: {
        color: '#FFF',
      },
    },
    MuiTabScrollButton: {
      root: {
        backgroundColor: FLOW_COLOR,
        color: '#FFF',
        '&$disabled': {
          opacity: 0.8,
          color: FLOW_COLOR,
        },
      },
    },
    MuiTableRow: {
      root: {
        '&$selected': {
          backgroundColor: 'rgba(210, 219, 250, 0.85)',
        },
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: '0.750rem',
        fontWeight: 400,
        backgroundColor: 'rgb(97, 97, 97)',
      },
    },
    MuiLink: {
      root: {
        color: FLOW_COLOR,
        fontFamily: 'Roboto',
        letterSpacing: -0.5,
      },
    },
  },
};



// WEBPACK FOOTER //
// ./containers/themes/cpmManager.js